module.exports = __webpack_public_path__ + "img/i_refresh.5a1ed23e.svg";